import { Events } from "src/types/language";
import * as yup from "yup";

const _msg = (message: Events): Events => message;

const passwordSchema = yup
  .string()
  .required(_msg("error.password.required"))
  .min(6, _msg("error.password.min"))
  .max(28, _msg("error.password.max"));
const rules = {
  email: yup
    .string()
    .required(_msg("error.email.required"))
    .email(_msg("error.email.format")),
  password: passwordSchema,
  description: yup.string().required(_msg("error.description.required")),
  nikname: yup.string().required(_msg("error.nikname.required")),
  terms: yup.boolean().oneOf([true], _msg("error.terms.required")),
  code: yup
    .string()
    .required(_msg("error.code.required"))
    .min(1, _msg("error.code.min"))
    .max(8, _msg("error.code.max")),
  contact: yup
    .string()
    .test("is-email-or-phone", _msg("error.contact.invalid"), function (value) {
      if (!value) return false;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[\d\s()+-]{7,20}$/;
      return emailRegex.test(value) || phoneRegex.test(value);
    }),
  name: yup.string().required(_msg("error.name.required")),
  date: yup
    .string()
    .required(_msg("error.date.required"))
    .matches(/^\d{2}\.\d{2}\.\d{4}$/, _msg("error.date.format"))
    .test("is-valid-date", _msg("error.date.invalid"), (value) => {
      if (!value) return false;
      const [dayStr, monthStr, yearStr] = value.split(".");
      const day = parseInt(dayStr, 10);
      const month = parseInt(monthStr, 10);
      const year = parseInt(yearStr, 10);

      if (isNaN(day) || isNaN(month) || isNaN(year)) return false;
      if (month < 1 || month > 12) return false;
      const daysInMonth = [
        31,
        year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];

      if (day < 1 || day > daysInMonth[month - 1]) return false;

      return true;
    }),
  results: yup
    .array()
    .max(2, _msg("error.results.min"))
    .min(2, _msg("error.results.min"))
    .required(_msg("error.results.required")),
  promoCode: yup.string().required(_msg("error.promoCode.required")),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], _msg("error.password.match"))
    .required(_msg("error.password.required")),
};

export const validators = {
  editProfile: yup.object().shape({
    email: rules.email,
    password: yup
      .string()
      .test(
        "min-length-if-filled",
        _msg("error.password.min"),
        (value) => !value || value.length >= 6,
      ),
  }),
  forgetPassword: yup.object().shape({
    email: rules.email,
  }),
  register: yup.object().shape({
    email: rules.email,
    password: rules.password,
    terms: rules.terms,
  }),
  login: yup.object().shape({
    email: rules.email,
    password: rules.password,
  }),
  verifyForm: yup.object().shape({
    code: rules.code,
  }),
  addEmailForm: yup.object().shape({
    email: rules.email,
    password: rules.password,
  }),
  deposit: yup.object().shape({}),
  addEvent: yup.object().shape({
    name: rules.name,
    date: rules.date,
    results: rules.results,
  }),
  promoCodeForm: yup.object().shape({
    promoCode: rules.promoCode,
  }),
  resetPassword: yup.object().shape({
    password: passwordSchema,
    confirmPassword: rules.confirmPassword,
  }),
};
